import type { UploadFetch } from "@/upload";
import { getCrsInfo } from "@/crs";
import { normalizeInputProjection, validateInputProjection } from "@/projection";
import React, { useEffect, useState } from "react";

export function useProjectionName(crs: string, request?: UploadFetch) {
    const [result, setResult] = useState<{ crs: string; name: string | null }>({ crs: "", name: null });

    useEffect(() => {
        const normalized = normalizeInputProjection(crs);
        if (!normalized.startsWith("EPSG:") || !validateInputProjection(normalized)) return;

        const codes = normalized.slice(5).split("+");
        if (codes.some((code) => code.length < 4)) return;

        let active = true;
        const timeout = window.setTimeout(() => {
            Promise.all(codes.map((code) => getCrsInfo(code, request).catch(() => null))).then((results) => {
                if (active) {
                    const names = results.map((result) => result?.name ?? null);
                    setResult({ crs, name: names.every((name) => name !== null) ? names.join(" + ") : null });
                }
            });
        }, 300);

        return () => {
            active = false;
            clearTimeout(timeout);
        };
    }, [crs, request]);

    return result.crs === crs ? result.name : null;
}

export const ProjectionName: React.FC<{ crs: string }> = ({ crs }) => {
    const name = useProjectionName(crs);
    return name ? <div className="text-xs text-gray-50">{name}</div> : null;
};
